Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller

    constructor: (@scope, @transitions, @repo, loader, $q, @state, @modal) ->
        super(@scope, @transitions)

        # loading stuff
        loader.overSidebar 'Loading...'

        things_to_load = [
            @loadCrops()
        ]
        $q.all(things_to_load).then (result) =>
            loader.hideAll()

        # set default tab state
        # TODO: make this conditional based on completion of setup phase
        if @state.is 'portal.ratings'
            @state.go 'portal.ratings.setup', null,
                location: 'replace'

        # scope variables
        @scope.crops = []
        @scope.selected =
            crop: null
        @scope.$state = @state
        # @scope.show_fullpage = true


    loadCrops: =>
        promise = @repo.getCrops().then (response) =>
            if response.status?.type isnt 'success'
                @showLoadCropsError(response.status?.msg)
                return

            @scope.crops.length = 0
            for crop in response.data.crops
                @scope.crops.push(crop)

            # if there's only one crop, automatically select it
            if @scope.crops.length is 1
                @scope.selected.crop = @scope.crops[0]

        .catch (response) =>
            @showLoadCropsError()

        return promise

    showLoadCropsError: (msg) =>
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to load Crops: #{msg}"
        else
            # otherwise just give a generic error
            msg = 'Failed to load Crops'

        @showError msg

    showError: (msg) =>
        # TODO: show the error
        # for now we'll just alert it
        alert(msg)
